import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import imageSelecter from '../../components/_image_selecter';
import flashMessageMixin from '../../mixins/_flash_messages';
import modalYahooAuth from '../../components/_modal_yahoo_auth';
import selectTemplateComponent from './_select-template-component';
import modalStoreTemplateChange from './_modal_store_template_change';
import edit from './_edit';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import previewComponent from './_preview-component';

const view = '[data-view="build_store"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // テンプレート取得実行済みフラグ
                is_executed_set_template: false,
                // 編集ID
                edit_id: null,
                // ショップ全体の設定テンプレートデータ
                template: {},
                // 連動フラグ
                device_sync: false,
                // 編集指定ブロック
                edit_area: null,
            };
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            commonMixin,
            modalMixin,
            flashMessageMixin,
            chromeExtensionMixin
        ],
        /**
         * コンポーネント群
         */
        components: {
            // 画像の選択、UPロードを操作するコンポーネント
            'image-selecter': imageSelecter,
            // テンプレート選択画面(看板作成画面)
            'select-template': selectTemplateComponent,
            // ストアテンプレート選択モーダル
            'modal-store-template-change': modalStoreTemplateChange,
            // ストア編集画面コンポーネント
            'edit': edit,
            // ヤフーAPIトークン認証チェックコンポーネント
            'modal-yahoo-auth': modalYahooAuth,
            // プレビュー
            'preview': previewComponent,
        },
        /**
         * 算出プロパティ
         */
        computed: {
            // テンプレートデータがあるか否か
            hasTemplate: function () {
                return (Object.keys(this.template).length > 0);
            },
            // 現在の画面
            display: function () {
                // テンプレート取得が実行されていない場合はnullを返す
                if (!this.is_executed_set_template) {
                    return null;
                }
                // テンプレートがなければ選択画面へ
                if (!this.hasTemplate) {
                    return 'select_template';
                }
                return 'edit';
            },
            // 編集データ
            edit_data: {
                get() {
                    if (this.hasTemplate && this.edit_area) {
                        return this.template[this.edit_area];
                    }
                    return  {};
                },
                set(value) {
                    if (this.hasTemplate && this.edit_area) {
                        this.template[this.edit_area] = value;
                    } else {
                        this.template = {};
                    }
                }
            },
            // 編集エリアはPCトップか
            isEditAreaFreeText: function () {
                return this.edit_area === 'freetext';
            },
            //  編集エリアはスマホトップか
            isEditAreaSpFreeText: function () {
                return this.edit_area === 'spfreetext1';
            },
        },
        watch: {
            // 編集画面はグローバルヘッダ非表示
            display: function (value) {
                console.log('display: ' + value);
                this.$_showGlobalHeader(value === 'edit');
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // ヤフーTOKEN認証チェック後に初回実行処理
            isValidToken: async function (boolean) {
                if (!boolean) {
                    return;
                }
                this.setEditId();
                this.is_executed_set_template = await this.setTemplate();
            },
            // 編集IDをセット
            setEditId: function (editId = null) {
                // 指定があれば
                if (editId) {
                    this.edit_id = editId;
                // 指定がなくadminでなければ
                } else if (!this.isAdmin) {
                    this.edit_id = 'production';
                // 指定がなくadminであれば新規編集ID
                } else {
                    this.edit_id = moment().unix();
                }
                console.log('edit_id: ' + this.edit_id);
            },
            // テンプレートデータをセットする
            setTemplate: async function (template = null, isTakeOver = false) {
                const params = this.$_params();
                // テンプレート選択からemitされた場合
                if (template) {
                    // 元パーツの引き継ぎがON
                    // (テンプレート再選択時のみisTakeOverが渡される)
                    if (isTakeOver) {
                        // 元パーツ情報を結合
                        const areas = template[0];
                        Object.keys(areas).forEach((area) => {
                            const parts = areas[area]['parts'].concat(this.template[area]['parts']);
                            return areas[area]['parts'] = parts;
                        }, this);
                        // スマホ連動フラグは上書きしない
                        template[1] = this.device_sync;
                    }
                    [this.template, this.device_sync] = template;
                    // 文字数を計算し直す
                    this.$refs.edit.getRefStaticHtml();
                    return true;
                }
                // 通常取得
                if (typeof params.id === 'undefined') {
                    [this.template, this.device_sync] = await this.getPage();
                    return true;
                }
                // 下書き取得
                if (typeof params.copy === 'undefined') {
                    this.setEditId(params.id);
                    [this.template, this.device_sync] = await this.getPage(params.id);
                    return true;
                }
                // 下書きコピー
                if (params.copy === 'draft') {
                    [this.template, this.device_sync] = await this.getPage(params.id, this.edit_id);
                    return true;
                }
            },
            // ページデータを取得
            getPage: async function (editId = null, copyDstId = null) {
                let data = [{}, false];
                let message = this.exception_error_message;
                this.$_loading();
                try {
                    const response = await axios.get('/build_store/get_page', {
                        params: {
                            edit_id: editId,
                            copy_dst_id: copyDstId,
                        }
                    });
                    if (response.data.status == 'OK' && response.data.data) {
                        data = [response.data.data.template, response.data.data.device_sync];
                        message = '';
                    } else {
                        message = response.data.message;
                    }
                } catch (e) {
                    message = this.getCatchMessage(e);
                }
                this.$_unloading();
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
                return data;
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
